import React from 'react';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';

import { TP_COLORS } from '../../constants';

const CustomSlider = styled(Slider)(({ theme }) => ({
  color: 'transparent',
  height: 3,
  margin: '0px 21px',
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 40,
    width: 40,
    color: TP_COLORS.white,
    backgroundColor: TP_COLORS.black,
    borderRadius: '7px',
    boxShadow: 'none',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'none',
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 6,
  },
}));

interface PageSliderProps {
  totalPages: number;
  pageNo: number;
  onChangePage: (pageNo: string) => void;
}

const PageSlider: React.FC<PageSliderProps> = ({
  totalPages,
  pageNo,
  onChangePage,
}) => {
  const handleChange = (event: Event, newValue: number | number[]) => {
    onChangePage(newValue.toString());
  };

  const CustomThumbComponent = (props: React.HTMLAttributes<unknown>) => {
    const { children, ...other } = props;
    return (
      <SliderThumb {...other}>
        {children}
        {pageNo}
      </SliderThumb>
    );
  };
  return (
    <CustomSlider
      min={1}
      max={totalPages}
      onChange={handleChange}
      components={{
        Thumb: CustomThumbComponent,
      }}
      value={pageNo}
    />
  );
};

export default PageSlider;
